import React, { useState, useEffect } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function ActualizaEstandar(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [postElemento, setPostElemento] = useState(props.elemento || "");
  const [postFortaleza, setPostFortaleza] = useState(props.fortaleza || "");
  const [postOportunidad, setPostOportunidad] = useState(
    props.oportunidad || "",
  );

  useEffect(() => {
    setPostElemento(props.elemento || "");
    setPostFortaleza(props.fortaleza || "");
    setPostOportunidad(props.oportunidad || "");
  }, [props.elemento, props.fortaleza, props.oportunidad]);

  const postData = (e) => {
    e.preventDefault();

    axios({
      method: "put",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ActualizaEstandarCualitativo/" +
        props.id,
      data: {
        fortalezas: postFortaleza,
        elementosVerificacion: postElemento,
        oportunidadMejora: postOportunidad,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        alert("Actualizado con exito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al Actualizar" + error);
      });
  };

  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-warning"
        onClick={handleOpenModalTest}
      >
        Editar
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Editar Información
                  </h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <form className="user" onSubmit={postData}>
                      <div className="form-group row">
                        <div className="col-sm-12">
                          Elementos de Verificación
                          <textarea
                            rows={6}
                            type="text"
                            className="form-control"
                            value={postElemento}
                            onChange={(e) => setPostElemento(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-12">
                          Fortalezas
                          <textarea
                            rows={6}
                            type="text"
                            className="form-control"
                            value={postFortaleza}
                            onChange={(e) => setPostFortaleza(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-12">
                          Oportunidad de Mejora
                          <textarea
                            rows={6}
                            type="text"
                            className="form-control"
                            value={postOportunidad}
                            onChange={(e) => setPostOportunidad(e.target.value)}
                          />
                        </div>
                      </div>

                      <hr />
                      <button
                        type="submit"
                        className="btn btn-primary btn-user btn-block"
                      >
                        Guardar
                      </button>
                      <hr />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default ActualizaEstandar;
